import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import es from "./locales/es.json";
import ar from "./locales/ar.json";
import de from "./locales/de.json";
import fr from "./locales/fr.json";
import hi from "./locales/hi.json";
import id from "./locales/id.json";
import ja from "./locales/ja.json";
import ko from "./locales/ko.json";
import pt from "./locales/pt.json";
import ru from "./locales/ru.json";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    es: { translation: es },
    ar: { translation: ar },
    de: { translation: de },
    fr: { translation: fr },
    hi: { translation: hi },
    id: { translation: id },
    ja: { translation: ja },
    ko: { translation: ko },
    pt: { translation: pt },
    ru: { translation: ru },
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export const SUPPORTED_LANGS = ["es", "ar", "de", "fr", "hi", "id", "ja", "ko", "pt", "ru"];

export const LANGUAGES = [
  { code: "en", name: "English",    flag: "🇬🇧" },
  { code: "es", name: "Español",    flag: "🇪🇸" },
  { code: "ar", name: "العربية",   flag: "🇸🇦" },
  { code: "de", name: "Deutsch",    flag: "🇩🇪" },
  { code: "fr", name: "Français",   flag: "🇫🇷" },
  { code: "hi", name: "हिन्दी",    flag: "🇮🇳" },
  { code: "id", name: "Indonesia",  flag: "🇮🇩" },
  { code: "ja", name: "日本語",     flag: "🇯🇵" },
  { code: "ko", name: "한국어",     flag: "🇰🇷" },
  { code: "pt", name: "Português",  flag: "🇧🇷" },
  { code: "ru", name: "Русский",    flag: "🇷🇺" },
];

export default i18n;
